import React, { useEffect, useRef, useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import { DevicesVM } from '../../Structure/ViewModels/Admin/DevciesVM'

const Devices = () => {
    const [vm , setVm] = useState<{viewModel:DevicesVM}>({viewModel:new DevicesVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getList()
    },[])

    const addingButton= useRef<HTMLButtonElement>(null)
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
          addingButton.current?.click()
        }
      };


  return (
    <Row className='w-100 p-0 m-0'>
        <h5 className='py-5 text-center'>قائمة الاجهزة</h5>
        <div className='px-5 d-flex'>
            <div className='p-3 d-flex justify-content-between'>
                <input type="text" className='input-field w-100' value={control.Name} onChange={(a)=>control.Name= a.target.value} onKeyDown={handleKeyDown} />
                <div className='px-3'></div>
                <button ref={addingButton} className='button-II btn-cl-I p-2 m-auto material-symbols-outlined' onClick={()=>control.addDevice()}>add</button>
            </div>
        </div>
        <Col md={12} className='d-flex flex-column h-100'>

        {
            control.Show(
        <div className='d-flex p-3 overflow-x-auto w-100'>
            <table className='w-100 text-center' style={{minWidth:'700px'}}>
                <tr className='txt-color-I bg-light-gray'>
                    <th>رقم الجهاز</th>
                    <th>اسم الجهاز</th>
                    <th>كلمة السر</th>
                    <th>الحالة</th>
                    <th>ايقاف</th>
                    <th>ازالة</th>
                </tr>
                {
                control.List.map((item,index)=>(
                    <tr  key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                        <td>{item.id}</td>
                        <td>{item.name}</td>
                        <td>{item.password}</td>
                        <td>{item.status==='active'?'نشط':'غير نشط'}</td>
                        <td className='d-flex justify-content-center'>
                            <button className='button-I btn-cl-I px-5 py-1' style={{display:item.status==='active'?'flex':'none'}} onClick={()=>control.deactivateDevice(item.id)}>ايقاف</button>
                        </td>
                        <td>
                            <button className='button-I btn-cl-I px-5 py-1' onClick={()=>control.removeDevice(item.id)}>ازالة</button>
                        </td>
                    </tr>
                ))
                }
            </table>
        </div>)
        }
        </Col>
    </Row>
  )
}

export default Devices
